import styled, { css } from 'styled-components';

export const ModalContent = styled.div(
  ({ theme }) => css`
    padding: ${theme.sz.s8};
  `,
);

export const ModalHeader = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.m};
    margin-bottom: ${theme.sz.s3};
    text-align: center;
  `,
);

export const ModalDescription = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.l};
    margin-bottom: ${theme.sz.s6};
  `,
);
